/**
 * ドライバー指示メモ
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/orders`

 const allocation_order_instruction = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    edit ({ commit }, { order_id }) {
      const api_path = `${API_PATH}/${order_id}/instructions/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { order_id, params }) {
      const api_path = `${API_PATH}/${order_id}/instructions`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
 }
 export default allocation_order_instruction
